import { Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import Staff from "../../../actions/staff";
import {
  Autocomplete,
  FormHelperText,
  MenuItem,
  Typography,
  Box,
} from "@mui/material";
import Controls from "../../../components/controls/Controls";
import { Form } from "../../../components/customHelpers/useForm";
import TextField from "@material-ui/core/TextField";
import CheckIcon from "@mui/icons-material/Check";
import Order from "../../../actions/order";

const Assigntff = ({
  NotifyMessage,
  setOpenPopup,
  id,
  getAllOrders,
  handleStatusChange,
  event,
  type
}) => {
  const { viewStoreKeepers, viewAllStaff } = Staff();
  const { OrderAssigned } = Order();
  const [staff, setStaffs] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState(null); // Updated to store full staff info
  const [roleError, setRoleError] = useState(false);

  useEffect(() => {
    getAllStaffs();
  }, []);

  const getAllStaffs = () => {
    if (handleStatusChange) {
      viewStoreKeepers().then((data) => {
        if (data.err) {
          NotifyMessage({
            message: data.err,
            type: "error",
          });
        } else if (data.staffs) {
          // Update the state with the fetched staff
          setStaffs((prevStaffs) => [...prevStaffs, ...data.staffs]);
        }
      });
    } else {
      viewAllStaff().then((data) => {
        if (data.err) {
          NotifyMessage({
            message: data.err,
            type: "error",
          });
        } else if (data.staffs) {
          setStaffs(data.staffs);
        }
      });
    }
  };
  
  const handleChange = (event, newValue) => {
    if (newValue) {
      setSelectedStaff(newValue); // Store full staff info
    }
  };

  const handleSubmit = () => {
    const user={
      fullName: selectedStaff.fullName,
      type : type
    }
    OrderAssigned(
      { user, id: selectedStaff.id },
      id
    ).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.order) {
        NotifyMessage({
          message: "Order Assigned",
          type: "success",
        });
        setOpenPopup(false);
        getAllOrders();
        if (handleStatusChange !== null) {
          handleStatusChange(event);
        }
      }
    });
  };

  const handleAddClick = (e) => {
    e.preventDefault();

    if (selectedStaff === null) {
      setRoleError(true);
    } else {
      setRoleError(false);
      handleSubmit();
    }
  };

  return (
    <Form onSubmit={handleAddClick}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <>
            <Autocomplete
              options={staff}
              getOptionLabel={(option) => option.fullName}
              onChange={handleChange}
              value={selectedStaff} // Use 'selectedStaff' instead of 'selectedOptions'
              renderInput={(params) => (
                <TextField {...params} variant="outlined" label="Select User" />
              )}
              renderOption={(props, option, { selected }) => (
                <MenuItem
                  {...props}
                  key={option.id}
                  value={option.id}
                  sx={{ justifyContent: "space-between" }}
                >
                  {option.fullName}
                  {selected ? <CheckIcon color="info" /> : null}
                </MenuItem>
              )}
            />
            {roleError && (
              <FormHelperText error>Please select one User</FormHelperText>
            )}
          </>
        </Grid>

        {/* Display staff details conditionally */}
        {selectedStaff && (
          <Grid item xs={12} md={6}>
            <Box mt={2}>
              <Typography variant="body1">
                <strong>Phone Number:</strong> {selectedStaff.phoneNo}
              </Typography>
              <Typography variant="body1">
                <strong>Role:</strong>{" "}
                {selectedStaff.staffRoles.length > 0
                  ? selectedStaff.staffRoles[0].role.name
                  : selectedStaff.role}
              </Typography>
            </Box>
          </Grid>
        )}
        {!selectedStaff && <Grid item xs={12} md={6} />}

        <Grid item xs={12} md={6}>
          <div>
            <Controls.Button
              text={"Assign"}
              variant="contained"
              className="Button"
              type="submit"
            />
            <Controls.Button
              text={"Cancel"}
              variant="contained"
              className="Button"
              onClick={() => {
                setOpenPopup(false);
              }}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default Assigntff;
